module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ({

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var PATTERN_IDCARD = /(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/;
var PATTERN_MOBILE = /^1[0-9]{10}$/;
var PATTERN_TELEPHONE = /^[0-9\+][0-9-]*\d+$/;
var PATTERN_EMAIL = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

var required = function required(msg) {
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';
  return {
    required: true,
    message: msg,
    trigger: trigger
  };
};

var csdCode = function csdCode() {
  return {
    required: true,
    validator: function validator(rule, value, callback) {
      if (value && (value.length === 15 || value.length === 18) && /^[A-Za-z0-9]+$/.test(value)) {
        callback();
      } else {
        callback(new Error('请输入15位或18位营业执照注册号'));
      }
    },
    trigger: 'blur'
  };
};

var pattern = function pattern(_pattern, msg) {
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  return [{
    required: true,
    message: "\u8BF7\u8F93\u5165".concat(msg),
    trigger: trigger
  }, {
    required: true,
    pattern: _pattern,
    message: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684".concat(msg),
    trigger: trigger
  }];
};

var idNumber = function idNumber(msg) {
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';
  return pattern(PATTERN_IDCARD, msg, trigger);
};

var mobile = function mobile(msg) {
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';
  return pattern(PATTERN_MOBILE, msg, trigger);
};

var telephone = function telephone(msg) {
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';
  return pattern(PATTERN_TELEPHONE, msg, trigger);
};

var email = function email(msg) {
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';
  return pattern(PATTERN_EMAIL, msg, trigger);
};

var dateRang = function dateRang(msg) {
  return {
    required: true,
    validator: function validator(rule, value, callback) {
      var start = value.start,
          end = value.end,
          long = value.long;

      if (start && end || start && long) {
        callback();
      } else {
        callback(new Error(msg));
      }
    },
    trigger: 'blur'
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  required: required,
  csdCode: csdCode,
  idNumber: idNumber,
  mobile: mobile,
  telephone: telephone,
  email: email,
  dateRang: dateRang
});

/***/ })

/******/ });